import { useMemo } from 'react';

/**
 * Iframe d'aperçu d'un thème : injecte un document HTML complet
 * (CSS + pages assemblées) de façon isolée et sécurisée.
 */
export default function ThemePreviewFrame({
  documentHtml,
  title = 'Aperçu du thème',
  className = '',
}: {
  documentHtml: string;
  title?: string;
  className?: string;
}) {
  const srcDoc = useMemo(() => documentHtml, [documentHtml]);

  return (
    <iframe
      title={title}
      srcDoc={srcDoc}
      sandbox="allow-scripts"
      className={`w-full h-full border-0 bg-background-50 ${className}`}
    />
  );
}